<template>
    <c-dialog ref="dialog" mode="slide" width="70vw" mask-close @resolve="submitHandle">
        <c-form ref="purchaseForm" column="3" vertical unit-width="100%">
            <c-title>入库商品明细</c-title>
            <c-form-item :label="false" colspan="3">
                <m-operate border>
                    <c-input ref="codeInput" name="purchase_code" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanCodeHandle">
                        <template #appendIcon><i class="tf-scan"></i></template>
                    </c-input>
                    <c-input ref="purchaseInput" name="purchase_order_code" v-model="purchaseCode" placeholder="请输入采购单号" @keyup.enter.native="scanPurchaseOrderHandle">
                    </c-input>
                    <c-button color="main" @click="confirmHandle">确定</c-button>
                    <c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
                </m-operate>
                <c-table ref="productTable" :data="scannedList" border :paging="false">
                    <template #empty>
                        <c-empty message="请扫描产品背贴码或输入采购单号"></c-empty>
                    </template>

                    <c-table-column type="selector" width="40"></c-table-column>
                    <c-table-column label="产品信息" width="220">
                        <template #default="{data}">{{getProductText(data)}}</template>
                    </c-table-column>
                    <c-table-column label="背贴码" width="140">
                        <template #default="{data}">{{data.produce_unique_code}}</template>
                    </c-table-column>
                    <c-table-column label="IMEI" width="150">
                        <template #default="{data}">{{data.produce_imei || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="关联采购单" width="150">
                        <template #default="{data}">
                            <span v-if="data.purchase_code">
                                <c-link v-if="auth('m_purchase_offline') || auth('m_purchase_online') || auth('m_purchase_bidding')" class="link-text"
                                        @click="globalDialog('purchaseDetail', {props: {id:data.purchase_order_id}})">
                                {{data.purchase_code}}
                                </c-link>
                                <span v-else>
                                    {{data.purchase_code}}
                                </span>
                            </span>
                            <span v-else>-</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="采购价" width="90">
                        <template #default="{data}">
                            <span class="price-text">{{data.purchase_price ? '¥' + data.purchase_price : '-'}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="供应商" width="160">
                        <template #default="{data}">{{data.supplier_name || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="备注" min-width="100">
                        <template #default="{data}">{{data.remark || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="采购时间" width="150">
                        <template #default="{data}">{{data.purchase_date || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="操作" width="80" type="button">
                        <template #default="{data}">
                            <c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import importExcelAnalysis from "@/pages/system/import_excel_analysis.vue";
import scanCodeGuard from '@/mixins/scan_code_guard';

export default {
    name: 'code_storage_in',
    components: {importExcelAnalysis},
    mixins: [scanCodeGuard],

    data() {
        return {
            scanCode: '',          //背贴码
            purchaseCode: '',      //采购单
            scannedList: [],       //已加载的唯一码列表
            purchase_order_id: 0,
            editState: false,
            supplierId: 0,       //已选中的供应商ID
            supplierContactId: 0,       //已选中的供应商ID
            supplierContactSelected: [],//已选中的供应商信息
            sysuserOptions: [],//已选中的采购员
            deleteProductList: [],
            payeeUserType:1,
            payeeUserTypeOptions:[
                {name: '采购员',value: 1,color: 'blue'},
                {name: '供应商',value: 2,color: 'gray'},
            ]
        }
    },

    methods: {
        /*********聚焦输入框**********/
        focusInput() {
            this.$nextTick(() => {
                var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
                if (input) input.focus();
            });
        },
        focusPurchaseInput() {
            this.$nextTick(() => {
                var input = this.$refs.purchaseInput && this.$refs.purchaseInput.$el.querySelector('input');
                if (input) input.focus();
            });
        },

        /*********【背贴码】扫码处理**********/
        scanCodeHandle() {
            var code = this.scanCode.trim();
            if (!code) {
                this.$message({message: '请输入背贴码', type: 'warn'});
                return;
            }
            if (this.scannedList.some(item => item.produce_unique_code == code)) {
                this.$message({message: '该背贴码已录入', type: 'warn'});
                this.scanCode = '';
                this.focusInput();
                return;
            }
            //防止连续点击【确定】对同一背贴码并发请求，导致已扫列表重复录入
            if (this.isScanCodePending(code)) {
                this.$message({message: '该背贴码正在校验，请勿重复提交', type: 'warn'});
                return;
            }
            this.lockScanCode(code);
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code,
                    action_type: 4  //4=待入库
                },
                success: (data) => {
                    if (this.scannedList.some(item => item.produce_unique_code == code)) {
                        this.$message({message: '该背贴码已录入', type: 'warn'});
                    } else {
                        if(data.purchase_state != 4){
                            this.$message({message: '该背贴码尚未采购确认，不允许入库', type: 'warn'});
                        }else if(data.main_state != 2){
                            this.$message({message: '该背贴码不是“待入库”状态，不允许入库', type: 'warn'});
                        }else {
                            this.pushScannedItem(data, code);
                        }
                    }
                    this.scanCode = '';
                    this.focusInput();
                },
                fail: (msg) => {
                    if (msg){
                        this.$message({message: msg, type: 'warn'});
                    }else {
                        this.$message({message: '背贴码不存在或已被删除，请检查', type: 'warn'});
                    }
                    this.scanCode = '';
                    this.focusInput();
                },
                complete: () => {
                    this.unlockScanCode(code);
                }
            });
        },

        /*********【采购单】扫码处理**********/
        scanPurchaseOrderHandle() {
            var purchaseCode = this.purchaseCode.trim();
            if (!purchaseCode) {
                this.$message({message: '请输入采购单号', type: 'warn'});
                return;
            }
            this.queryWaitInstorageList(purchaseCode);
        },
        //通过采购单号查询待入库商品详情
        queryWaitInstorageList(purchase_code) {
            //采购单号与背贴码共用同一套防重复锁，加前缀区分，防止连击重复查询
            var lockKey = 'purchase:' + purchase_code;
            if (this.isScanCodePending(lockKey)) {
                return;
            }
            this.lockScanCode(lockKey);
            //通过采购单号批量加载唯一码
            this.request({
                url: '/purchase/wait/instorage/list',
                data: {
                    purchase_code: purchase_code
                },
                success: (data) => {
                    let product_list = data.productList;
                    if (product_list && product_list.length > 0){
                        product_list = product_list.filter(item => {
                            return !this.scannedList.find(row => {
                                return row.produce_unique_code == item.produce_unique_code;
                            });
                        });
                        this.scannedList = this.scannedList.concat(product_list);
                    }else {
                        this.$message({message: '该采购单中无待入库商品，请检查', type: 'warn'});
                    }
                    this.purchaseCode = '';
                    this.focusPurchaseInput();
                },
                fail: (msg) => {
                    this.$message({message: '采购单不存在或已被删除，请检查', type: 'warn'});
                    this.purchaseCode = '';
                    this.focusPurchaseInput();
                },
                complete: () => {
                    this.unlockScanCode(lockKey);
                }
            });
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },

        /*********统一确定处理**********/
        confirmHandle() {
            if (this.scanCode.trim()) {
                this.scanCodeHandle();
            } else if (this.purchaseCode.trim()) {
                this.scanPurchaseOrderHandle();
            } else {
                this.$message({message: '请输入背贴码或采购单号', type: 'warn'});
            }
        },
        /*********移除已扫项**********/
        removeItem(data) {
            this.scannedList = this.scannedList.filter(item => item.id != data.id);
            this.focusInput();
        },

        /*********批量移除选中项**********/
        batchRemove() {
            let selectedList = this.$refs.productTable.getData('selected');
            if (!selectedList || selectedList.length == 0) {
                this.$message({message: '请先勾选要移除的记录', type: 'warn'});
                return;
            }
            var ids = selectedList.map(item => item.id);
            this.scannedList = this.scannedList.filter(item => !ids.includes(item.id));
            this.focusInput();
        },

        //打开弹窗
        /**
         * @param type 入库类型 1=按条码  2=按采购单
         * @param codes  条码 或 采购单号集合
         */
        open(type,codes) {
            this.scannedList = [];
            this.$refs.dialog.open({
                title: '批量入库'
            });
            //自动定位到【背贴码输入框】
            if (type == 2){
                this.focusPurchaseInput();
                if (codes && codes.length > 0) {
                    codes.forEach(item => {
                        this.queryWaitInstorageList(item);
                    });
                }
            }else {
                this.focusInput();
            }
        },

        /*******提交编辑数据********************/
        submitHandle(stop, next) {
            stop();
            var product_list = this.$refs.productTable.getData();
            if (!product_list || product_list.length == 0){
                this.$message({
                    message: '请至少输入一个入库商品',
                    type: 'warn'
                });
                return false;
            }
            //产品列表
            let produce_unique_code_list = product_list.map(item => {
                return item.produce_unique_code;
            });
            this.request({
                url: '/product/unique_code/instorage',
                data: {
                    produce_unique_code_list:produce_unique_code_list
                },
                loading: true,
                success: data => {
                    next();
                    this.$message({
                        message: '入库成功',
                        type: 'success'
                    });
                    //刷新页面
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.section-title {
    display flex
    align-items center
    margin 12px 0 8px
    .title-icon {
        width 4px
        height 16px
        background #1890ff
        border-radius 2px
        margin-right 8px
    }
    .c-title {
        margin 0
    }
}
.scan-toolbar {
    padding 8px 16px
    background #fafafa
    border 1px solid #e8e8e8
    border-bottom 0
    border-radius 4px 4px 0 0
    > * + * {
        margin-left 10px
    }
    .scan-input-box {
        position relative
        width 220px
        /deep/ .c-input input {
            background #fffbe6
            padding-right 32px
        }
        .scan-icon {
            position absolute
            right 10px
            top 50%
            transform translateY(-50%)
            color #999
            cursor pointer
        }
    }
}
.empty-state {
    padding 60px 0
    text-align center
    color #999
    .empty-icon {
        color #ccc
    }
    p {
        margin-top 10px
        font-size 14px
    }
}
.price-text {
    color #333
    text-decoration underline
}
.link-text {
    color #1890ff
    text-decoration underline
    cursor pointer
}
</style>